import React, { useEffect, useState } from "react";
import SliderContent from "./SliderContent";
import Dots from "./Dots";
import Arrows from "./Arrows";
// import sliderImage from "./SliderImages";
import "./slider.css";
import sliderImages from "./SliderImages";

let sliderImage = [
  {
    title: "First Slide",
    description: "This is the first slider Image of our carousel",
    urls: "https://s.rmjo.in/AirOKWeb%20(1).png",
  },
  {
    title: "First Slide",
    description: "This is the first slider Image of our carousel",
    urls: "https://s.rmjo.in/WP-Web.png",
  },
  // {
  //   title: "Second Slide",
  //   description: "This is the second slider Image of our carousel",
  //   urls: Third,
  // },
  // {
  //   title: "Third Slide",
  //   description: "This is the Third slider Image of our carousel",
  //   urls: Fourth,
  // },
  // {
  //   title: "Fourth Slide",
  //   description: "This is the Fourth slider Image of our carousel",
  //   urls: Fifth,
  // },
  // {
  //   title: "Fifth Slide",
  //   description: "This is the Fifth slider Image of our carousel",
  //   urls: Six,
  // },
  // {
  //   title: "Sixth Slide",
  //   description: "This is the Sixth slider Image of our carousel",
  //   urls: Seven,
  // },
  // {
  //  " title": "Seventh Slide",
  //   description: "This is the Seventh slider Image of our carousel",
  //   urls: Eight,
  // },
  // {
  //   " title": "Seventh Slide",
  //    description: "This is the Seventh slider Image of our carousel",
  //    urls: Nine,
  //  },
]

const len = sliderImages.length - 1;
console.log(sliderImages)

function Slider(props) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(activeIndex === len ? 0 : activeIndex + 1);
    }, 4000);
    return () => clearInterval(interval);
  }, [activeIndex]);

  return (
    <div className="slider-container">
      <SliderContent activeIndex={activeIndex} sliderImage={sliderImages} />
      <Arrows
        prevSlide={() =>
          setActiveIndex(activeIndex < 1 ? len : activeIndex - 1)
        }
        nextSlide={() =>
          setActiveIndex(activeIndex === len ? 0 : activeIndex + 1)
        }
      />
      
      <Dots
        activeIndex={activeIndex}
        sliderImage={sliderImages}
        onclick={(activeIndex) => setActiveIndex(activeIndex)}
      />
     
    </div>
  );
}

export default Slider;
